export const PhotoItems = [
  {
    photo_id: 1,
    title: 'Neon Lighting',
    type: 'Neon',
    text: '“Strike me down and I will become more powerful than you could possibly imagine.”',
    imgSrc:
      'https://images.unsplash.com/photo-1589358524817-aaf5fd758a46?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1935&q=80',
    hashtags: 'Neon,Light,Red',
    photographer: 'Obi Wan Kenobi',
    photographer_info:
      'In the original trilogy he is introduced as Ben Kenobi, an alias he uses while in hiding from the Empire. He is a mentor to Luke Skywalker, to whom he introduces the ways of the Jedi. After sacrificing himself in a duel against Darth Vader, Obi-Wan guides Luke through the Force in his fight against the Galactic Empire. ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/3/32/Ben_Kenobi.png',
  },
  {
    photo_id: 2,
    title: 'City Skyline',
    type: 'Street Photography',
    text: '“I find your lack of faith disturbing.”',
    imgSrc:
      'https://images.unsplash.com/photo-1617096259934-a44d708d975c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Skyline,Night,City,Scenery',
    photographer: 'Darth Vader',
    photographer_info:
      'Originally a slave on Tatooine, Anakin Skywalker is a Jedi prophesied to bring balance to the Force. He is lured to the dark side of the Force by Chancellor Sheev Palpatine / Darth Sidious and becomes a Sith Lord, assuming the title of Darth Vader.  ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/f/f7/Darth_Vader.png',
  },
  {
    photo_id: 3,
    title: 'Red Strawberries',
    type: 'Food',
    text: '“Yeah, I’m responsible these days. It’s the price you pay for being successful.”',
    imgSrc:
      'https://images.unsplash.com/photo-1619679347986-dc7b1c423e67?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    hashtags: 'Food,Strawberry,Natural',
    photographer: 'Lando Calrissian',
    photographer_info:
      ' Lando made a career as a gambler, con artist, playboy, mining engineer, and businessman, and was the owner of the Millennium Falcon until losing the ship to Han in a bet. In the film, when Cloud City is threatened by the Galactic Empire, Lando reluctantly betrays Han to Darth Vader. ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/c/cb/Lando6-2.jpg',
  },
  {
    photo_id: 4,
    title: 'Train Travelling in City',
    type: 'Live',
    text: '“Sometimes we must let go of our pride and do what is requested of us.”',
    imgSrc:
      'https://images.unsplash.com/photo-1579033014049-f33d9b14d37e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1964&q=80',
    hashtags: 'Live,Train,City',
    photographer: 'Padme Amidala',
    photographer_info:
      'First indirectly mentioned in Return of the Jedi, she is introduced in The Phantom Menace as the teenage Queen of Naboo, and after her reign, becomes a senator and an anti-war activist in the Galactic Senate. ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/e/ee/Amidala.png?20180113060156',
  },
  {
    photo_id: 5,
    title: 'Woman in White',
    type: 'Portrait',
    text: '“Who I am is not important, my message is.”',
    imgSrc:
      'https://images.unsplash.com/photo-1592921411716-e5ea119cc724?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Dark,People,White,Book',
    photographer: 'Darth Revan',
    photographer_info:
      'Revan is a former Jedi hero who lived during the Old Republic Era (roughly 4,000 years before the original Star Wars film trilogy). After turning to the dark side and becoming a Sith Lord, he took on the name Darth Revan and formed a Sith Empire to conquer the galaxy, contending with the Republics armies. ',
    photo:
      'https://starwarsevreni.com/wp-content/uploads/2016/06/darth-revan-1_sw-evreni.jpg.webp',
  },
  {
    photo_id: 6,
    title: 'Compass',
    type: 'Art',
    text: '“We fight for justice because justice is the fundamental bedrock of civilization: An unjust civilization is built upon sand. It does not long survive a storm.”',
    imgSrc:
      'https://images.unsplash.com/photo-1566340096944-7e0fcbd72189?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1907&q=80',
    hashtags: 'Compass,Mask,Man,Nature',
    photographer: 'Mace Windu',
    photographer_info:
      'Windu is a Jedi Master and member of the High Council during the final years of the Galactic Republic, who wields a unique purple-bladed lightsaber and is regarded as one of the most powerful Jedi of his time. He is a leading defender of the Old Republic in the Clone Wars, even as the conflict leads him to question his most firmly held beliefs. ',
    photo: 'https://upload.wikimedia.org/wikipedia/en/b/bf/Mace_Windu.png',
  },
  {
    photo_id: 7,
    title: 'Screengrab',
    type: 'Technology',
    text: '“Train yourself to let go of everything you fear to lose.” ',
    imgSrc:
      'https://images.unsplash.com/photo-1514401362266-c2757d33b379?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Tech,Phone,Building',
    photographer: 'Master Yoda',
    photographer_info:
      'He is a small, green humanoid alien who is powerful with the Force and is a leading member of the Jedi Order until its near annihilation. In The Empire Strikes Back, Yoda was voiced and puppeteered by Frank Oz, who reprised the role in Return of the Jedi, the prequel trilogy, and the sequel trilogy. ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/9/9b/Yoda_Empire_Strikes_Back.png',
  },
  {
    photo_id: 8,
    title: 'Chocolate Bar',
    type: 'Art',
    text: '“It’s every citizen’s duty to challenge their leaders, to keep them honest, and hold them accountable if they’re not.”',
    imgSrc:
      'https://images.unsplash.com/photo-1523035274455-b2e5c6d5c2e0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Art,Food',
    photographer: 'Ahsoka Tano',
    photographer_info:
      'Introduced as the Jedi Padawan of Anakin Skywalker, she is a supporting character in the animated film Star Wars: The Clone Wars and the subsequent animated television series. Ahsoka reappears in the sequel series Star Wars Rebels as a member of the Rebel Alliance. ',
    photo: 'https://upload.wikimedia.org/wikipedia/en/d/d7/Ahsoka_Tano.png',
  },
  {
    photo_id: 9,
    title: 'Fruits',
    type: 'Natural',
    text: '“No one’s ever really gone.” ',
    imgSrc:
      'https://images.unsplash.com/photo-1532904669358-3f7e745e45ad?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Natural,Fruit,Table',
    photographer: 'Luke Skywalker',
    photographer_info:
      'The son of fallen Jedi Knight Anakin Skywalker (turned Sith Lord Darth Vader) and Padmé Amidala, Luke is the twin brother of Rebellion leader Princess Leia and eventual brother-in-law of the smuggler Han Solo. ',
    photo: 'https://images6.alphacoders.com/874/874774.jpg',
  },
  {
    photo_id: 10,
    title: 'Neon Lighting',
    type: 'Neon',
    text: '“Strike me down and I will become more powerful than you could possibly imagine.”',
    imgSrc:
      'https://images.unsplash.com/photo-1589358524817-aaf5fd758a46?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1935&q=80',
    hashtags: 'Neon,Light,Red',
    photographer: 'Obi Wan Kenobi',
    photographer_info:
      'In the original trilogy he is introduced as Ben Kenobi, an alias he uses while in hiding from the Empire. He is a mentor to Luke Skywalker, to whom he introduces the ways of the Jedi. After sacrificing himself in a duel against Darth Vader, Obi-Wan guides Luke through the Force in his fight against the Galactic Empire. ',
    photo:
      'https://initiate.alphacoders.com/images/913/cropped-1920-1080-913639.jpg?2999',
  },
  {
    photo_id: 11,
    title: 'City Skyline',
    type: 'Street Photography',
    text: '“I find your lack of faith disturbing.”',
    imgSrc:
      'https://images.unsplash.com/photo-1617096259934-a44d708d975c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Skyline,Night,City,Scenery',
    photographer: 'Darth Vader',
    photographer_info:
      'Originally a slave on Tatooine, Anakin Skywalker is a Jedi prophesied to bring balance to the Force. He is lured to the dark side of the Force by Chancellor Sheev Palpatine / Darth Sidious and becomes a Sith Lord, assuming the title of Darth Vader.  ',
    photo:
      'https://initiate.alphacoders.com/images/100/cropped-1920-1080-1006239.jpg?7826',
  },
  {
    photo_id: 12,
    title: 'Red Strawberries',
    type: 'Food',
    text: '“Yeah, I’m responsible these days. It’s the price you pay for being successful.”',
    imgSrc:
      'https://images.unsplash.com/photo-1619679347986-dc7b1c423e67?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1888&q=80',
    hashtags: 'Food,Strawberry,Natural',
    photographer: 'Lando Calrissian',
    photographer_info:
      ' Lando made a career as a gambler, con artist, playboy, mining engineer, and businessman, and was the owner of the Millennium Falcon until losing the ship to Han in a bet. In the film, when Cloud City is threatened by the Galactic Empire, Lando reluctantly betrays Han to Darth Vader. ',
    photo:
      'https://initiate.alphacoders.com/images/884/cropped-1920-1080-884077.jpg?2437',
  },
  {
    photo_id: 13,
    title: 'Train Travelling in City',
    type: 'Live',
    text: '“Sometimes we must let go of our pride and do what is requested of us.”',
    imgSrc:
      'https://images.unsplash.com/photo-1579033014049-f33d9b14d37e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1964&q=80',
    hashtags: 'Live,Train,City',
    photographer: 'Padme Amidala',
    photographer_info:
      'First indirectly mentioned in Return of the Jedi, she is introduced in The Phantom Menace as the teenage Queen of Naboo, and after her reign, becomes a senator and an anti-war activist in the Galactic Senate. ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/e/ee/Amidala.png?20180113060156',
  },
  {
    photo_id: 14,
    title: 'Woman in White',
    type: 'Portrait',
    text: '“Who I am is not important, my message is.”',
    imgSrc:
      'https://images.unsplash.com/photo-1592921411716-e5ea119cc724?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Dark,People,White,Book',
    photographer: 'Darth Revan',
    photographer_info:
      'Revan is a former Jedi hero who lived during the Old Republic Era (roughly 4,000 years before the original Star Wars film trilogy). After turning to the dark side and becoming a Sith Lord, he took on the name Darth Revan and formed a Sith Empire to conquer the galaxy, contending with the Republics armies. ',
    photo:
      'https://starwarsevreni.com/wp-content/uploads/2016/06/darth-revan-1_sw-evreni.jpg.webp',
  },
  {
    photo_id: 15,
    title: 'Compass',
    type: 'Art',
    text: '“We fight for justice because justice is the fundamental bedrock of civilization: An unjust civilization is built upon sand. It does not long survive a storm.”',
    imgSrc:
      'https://images.unsplash.com/photo-1566340096944-7e0fcbd72189?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1907&q=80',
    hashtags: 'Compass,Mask,Man,Nature',
    photographer: 'Mace Windu',
    photographer_info:
      'Windu is a Jedi Master and member of the High Council during the final years of the Galactic Republic, who wields a unique purple-bladed lightsaber and is regarded as one of the most powerful Jedi of his time. He is a leading defender of the Old Republic in the Clone Wars, even as the conflict leads him to question his most firmly held beliefs. ',
    photo: 'https://upload.wikimedia.org/wikipedia/en/b/bf/Mace_Windu.png',
  },
  {
    photo_id: 16,
    title: 'Screengrab',
    type: 'Technology',
    text: '“Train yourself to let go of everything you fear to lose.” ',
    imgSrc:
      'https://images.unsplash.com/photo-1514401362266-c2757d33b379?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Tech,Phone,Building',
    photographer: 'Master Yoda',
    photographer_info:
      'He is a small, green humanoid alien who is powerful with the Force and is a leading member of the Jedi Order until its near annihilation. In The Empire Strikes Back, Yoda was voiced and puppeteered by Frank Oz, who reprised the role in Return of the Jedi, the prequel trilogy, and the sequel trilogy. ',
    photo:
      'https://upload.wikimedia.org/wikipedia/en/9/9b/Yoda_Empire_Strikes_Back.png',
  },
  {
    photo_id: 17,
    title: 'Chocolate Bar',
    type: 'Art',
    text: '“It’s every citizen’s duty to challenge their leaders, to keep them honest, and hold them accountable if they’re not.”',
    imgSrc:
      'https://images.unsplash.com/photo-1523035274455-b2e5c6d5c2e0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Art,Food',
    photographer: 'Ahsoka Tano',
    photographer_info:
      'Introduced as the Jedi Padawan of Anakin Skywalker, she is a supporting character in the animated film Star Wars: The Clone Wars and the subsequent animated television series. Ahsoka reappears in the sequel series Star Wars Rebels as a member of the Rebel Alliance. ',
    photo: 'https://upload.wikimedia.org/wikipedia/en/d/d7/Ahsoka_Tano.png',
  },
  {
    photo_id: 18,
    title: 'Fruits',
    type: 'Natural',
    text: '“No one’s ever really gone.” ',
    imgSrc:
      'https://images.unsplash.com/photo-1532904669358-3f7e745e45ad?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1887&q=80',
    hashtags: 'Natural,Fruit,Table',
    photographer: 'Luke Skywalker',
    photographer_info:
      'The son of fallen Jedi Knight Anakin Skywalker (turned Sith Lord Darth Vader) and Padmé Amidala, Luke is the twin brother of Rebellion leader Princess Leia and eventual brother-in-law of the smuggler Han Solo. ',
    photo: 'https://images6.alphacoders.com/874/874774.jpg',
  },
];
